import React, { useMemo } from 'react';
import { toLpEcosystemSlug, toEcosystemSlug } from '@/utils';
import useGlobal from './useGlobal';

interface UseLpEcosystemNavigation {
  internalHref?: {
    slug?: string | null;
  } | null;
  externalHref?: string | null;
}

export function useLpEcosystemNavigation({ internalHref, externalHref }: UseLpEcosystemNavigation) {
  const global = useGlobal();
  const ctx = global?.state.ctx;
  return useMemo(() => {
    let internalHrefSlug = internalHref?.slug;
    let externalHrefSlug = externalHref;

    if (ctx && internalHrefSlug) {
      if (ctx?.lp) {
        internalHrefSlug = toLpEcosystemSlug({
          locale: ctx?.locale || 'en',
          slug: internalHrefSlug,
          tpv: ctx?.tpv || '',
          tg: ctx?.tg || false,
        });
      } else {
        internalHrefSlug = toEcosystemSlug({
          locale: ctx?.locale || 'en',
          slug: internalHrefSlug,
        });
      }
    }
    return {
      internalHrefSlug,
      externalHrefSlug,
    };
  }, [internalHref, externalHref, ctx]);
}
